import React from 'react';
import {UserApp} from '../../Context/AuthProvider/AuthProviderActions';
import {Form, Modal, Select} from 'antd';
import {useNavigate} from 'react-router-dom';
import {DiazarFormInput} from '../../Components/Form/DiazarFormInput';
import {useAlertDispatcherState} from '../../Context/AlertProvider/AlertProvider';
import {addAlert} from '../../Context/AlertProvider/AlertProviderActions';
import {useParameterizedQuery} from 'react-fetching-library';
import {unblockUser} from '../../Actions/Users/UsersActions';

interface ViewProps {
    keys: number[],
    isLoadingTable: React.Dispatch<React.SetStateAction<boolean>>
    user?: UserApp | undefined,
}

export const UnblockUserModal: React.FunctionComponent<ViewProps> = (props: ViewProps) => {
    const {user, keys, isLoadingTable} = props;
    const navigate = useNavigate();

    const [clave, setClave] = React.useState<string>('');
    const [isValidClave, setIsValidClave] = React.useState<boolean>(false);

    const [llave, setLlave] = React.useState<number>();

    const alertDistpatcher = useAlertDispatcherState();

    const unblockAction = useParameterizedQuery(unblockUser);

    const isModalOpen = React.useMemo(() => {
        return user !== undefined;
    }, [user]);

    const isValidLlave = React.useMemo(()=>{ return llave !== undefined && llave > 0;}, [llave]);
    const isValidForm = React.useMemo(()=>{ return isValidLlave && isValidClave;}, [isValidClave, isValidLlave]);
    const isLoading = React.useMemo(()=>{ return unblockAction.loading;}, [unblockAction.loading]);

    const handleOk = React.useCallback(() => {
        if (user === undefined || llave === undefined || clave === undefined) return;

        if (!isValidForm) return;

        const requestData = {
            id: user.id,
            clave: clave,
            ids: llave
        };

        unblockAction.query( requestData ).then( r => {
            if ( r.payload && !r.payload.error['has-error']){
                addAlert('Exito', 'Usuario desbloqueado con éxito.', 'success', alertDistpatcher);
                navigate('/');
                isLoadingTable(false);
            }
        } );


    }, [user, llave, clave, isValidForm, unblockAction, alertDistpatcher, navigate, isLoadingTable]);

    const handleCancel = React.useCallback(() => {
        navigate('/');
    }, [navigate]);

    const userClave = React.useMemo(() => {
        if (user === undefined) return '';

        const removalRegex = new RegExp(`_${user.id}$`);
        const uClave = user.clave.replace(removalRegex, '');

        setClave(uClave);

        return uClave;

    }, [user]);

    const MODAT_TITLE = React.useMemo(() => {
        if (user === undefined) return '';

        return `Desbloquar a: ${userClave}`;
    }, [user, userClave]);

    const OPTIONS = React.useMemo(() => {
        if (keys.length === 0 && user !== undefined){
            addAlert('Error', 'No hay llaves disponibles para desbloquear', 'error', alertDistpatcher);
            isLoadingTable(false);
            navigate('/');

            return [];
        }

        const opts = keys.map(k => {
            return {value: k, label: k.toString()};
        });

        if (opts.length > 0){
            setLlave(opts[0].value);
        }else{
            setLlave(undefined);
        }

        return opts;
    }, [alertDistpatcher, isLoadingTable, keys, navigate, user]);


    if (user === undefined) {
        return null;
    }

    return (
        <Modal
            title={MODAT_TITLE}
            closable={{'aria-label': 'Custom Close Button'}}
            open={isModalOpen}
            onOk={handleOk}
            okButtonProps={{disabled: !isValidForm || isLoading, loading: isLoading}}
            onCancel={handleCancel}
        >
            <Form
                labelCol={{span: 4}}
                wrapperCol={{span: 20}}
                autoComplete="off"
                layout="horizontal"
                style={{textAlign: 'justify'}}
            >
                <DiazarFormInput id="login-clave" label="Clave" isRequired
                                 type="text"
                                 placeholder="Clave de Usuario"
                                 getState={(isValid, value) => {
                                     setIsValidClave(isValid);
                                     setClave(value);
                                 }}
                                 initialValue={clave}
                                isReadOnly={isLoading}
                    //onPressEnter={ (isValidForm) ? handleLogin : undefined }
                />
                <Form.Item name="keys"
                           label="Llave"
                           rules={[
                               {
                                   required: true,
                                   message: 'Debes seleccionar una llave para desbloquear al usuario'
                               }
                           ]}
                >
                    <Select
                        showSearch
                        placeholder="Selecione una llave"
                        onChange={ (value) => {setLlave(value);} }
                        allowClear
                        options={OPTIONS}
                        value={llave}
                        defaultValue={llave}
                        aria-errormessage={'Por favor seleccione una llave'}
                        disabled={isLoading}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
